import React from 'react';
import PropTypes from 'prop-types';
import { manualUserVenuesPropTypes } from 'constants/propTypes';
import VenueMultiSelector from 'components/VenueMultiSelector';

const VenueToggleInput = ({ input: { value, onChange }, venues }) => {
  const selectedVenues = value || [];

  return (
    <VenueMultiSelector
      attachment="left"
      onChange={onChange}
      venues={venues.map(({ name, id }) => ({ venueName: name, venueId: id }))}
      selectedVenueIds={selectedVenues}
      hideSingleVenue={false}
    />
  );
};

VenueToggleInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.number)]),
    onChange: PropTypes.func,
  }),
  venues: manualUserVenuesPropTypes,
};

export default VenueToggleInput;
